(() => {
  if (customElements.get('yi2c-canvas-points')) return;
  customElements.define('yi2c-canvas-points', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.onOffer = event => {
        if (!event.target.closest('.yi2c-canvas-points__offer')) return;
        const strip = document.getElementById('homepage-trust-strip');
        const button = strip?.querySelector('[id^="trust-offer-"][aria-controls]');
        if (!button) return;
        event.preventDefault();
        if (button.getAttribute('aria-expanded') !== 'true') button.click();
        button.focus({preventScroll:true});
        strip.scrollIntoView({block:'center',behavior:'instant'});
      };
      this.addEventListener('click', this.onOffer);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onOffer);
      this.bound = false;
    }
  });
})();
